import { GMesh, ViewerModule } from "@g.frame/core";
import { DoubleSide, Group, Mesh, MeshBasicMaterial, PlaneBufferGeometry, TorusGeometry, Vector2 } from "three";
import { TextComponent } from "@g.frame/components.text";
export default class GaugeComponent extends ViewerModule {
    constructor() {
        super();
        this.mainContainer = new Group;
        this.numbers = new Group;
        this.addObject(this.mainContainer);
        this.mainContainer.add(this.numbers);
    }
    initGauge(config) {
        this.config = config;
        this.createScale();
        if (this.config.values.current) {
            this.rotateArrow(this.config.values.current / this.config.values.max);
        }
        this.createNumbers();
    }
    createNumbers() {
        const bodySize = new Vector2(.0075, .005);
        const pxScale = 1;
        this.numbers.position.set(0, 0, 0.0002);
        const min = new TextComponent({
            size: bodySize,
            pxSize: new Vector2(256 * bodySize.x / bodySize.y * pxScale, 256 * pxScale),
            text: {
                value: `${this.config.values.min}`,
                autoWrappingHorizontal: false,
                autoWrapping: false,
                align: 'center',
                style: {
                    family: 'ProximaNova',
                    weight: '600',
                    size: '183px',
                    color: '#000000'
                },
                margin: 0.001,
                lineHeight: 190,
            },
            background: {
                // color: 'white'
                color: 'transparent'
            }
        });
        min.uiObject.position.set(-0.00375, -0.005, 0);
        this.numbers.add(min.uiObject);
        const mid = new TextComponent({
            size: bodySize,
            pxSize: new Vector2(256 * bodySize.x / bodySize.y * pxScale, 256 * pxScale),
            text: {
                value: `${this.config.values.max / 2}`,
                autoWrappingHorizontal: false,
                autoWrapping: false,
                align: 'center',
                style: {
                    family: 'ProximaNova',
                    weight: '600',
                    size: '183px',
                    color: '#000000'
                },
                margin: 0.001,
                lineHeight: 190,
            },
            background: {
                // color: 'white'
                color: 'transparent'
            }
        });
        mid.uiObject.position.set(0, 0.00625, 0);
        this.numbers.add(mid.uiObject);
        const max = new TextComponent({
            size: bodySize,
            pxSize: new Vector2(256 * bodySize.x / bodySize.y * pxScale, 256 * pxScale),
            text: {
                value: `${this.config.values.max}`,
                autoWrappingHorizontal: false,
                autoWrapping: false,
                align: 'center',
                style: {
                    family: 'ProximaNova',
                    weight: '600',
                    size: '183px',
                    color: '#000000'
                },
                margin: 0.001,
                lineHeight: 190,
            },
            background: {
                // color: 'white'
                color: 'transparent'
            }
        });
        max.uiObject.position.set(0.00375, -0.005, 0);
        this.numbers.add(max.uiObject);
    }
    createScale() {
        const scaleGroup = new Group();
        const scale = 0.0016;
        scaleGroup.scale.setScalar(scale);
        const radius = 6.5;
        this.highlightTorus = new GMesh(new TorusGeometry(radius * scale * 1.55, .75 * scale, 8, 32), new MeshBasicMaterial({
            color: '#00FF00',
        }));
        this.highlightTorus.visible = false;
        this.mainContainer.add(this.highlightTorus);
        const mat = new MeshBasicMaterial({
            // color: '#111111',
            color: '#ff0002',
            side: DoubleSide,
        });
        const geoBase = new PlaneBufferGeometry(0.45, 2);
        const startRot = Math.PI * 3 / 4;
        const step = -startRot / 8;
        for (let i = 0; i < 17; i++) {
            const geo = geoBase.clone();
            if (i % 4 > 0) {
                geo.scale(1, 0.5, 0);
                geo.translate(0, radius + 0.5, 0);
            }
            else {
                geo.translate(0, radius, 0);
            }
            const point = new Mesh(geo, mat);
            point.rotation.z = startRot + step * i;
            scaleGroup.add(point);
        }
        this.mainContainer.add(scaleGroup);
    }
    rotateArrow(value) {
        const startRotation = .75;
        const full = 5.5 - .75;
        this.config.object.rotation.z = startRotation + value * full;
    }
}
